<div class="zoomControls" [ngClass]="{ 'zoomControls-new': newView }">
  <div class="zoomButtonGroup">
    <div class="zoomLevel">
      {{ zoomLevelDisplay }}
    </div>
    <glxy-button-group class="zoomButtons">
      <button mat-stroked-button [disabled]="_zoomLevel >= maxZoom" (click)="zoomIn()">
        <mat-icon>add</mat-icon>
      </button>
      <button mat-stroked-button (click)="resetZoom()">
        <mat-icon>youtube_searched_for</mat-icon>
      </button>
      <button mat-stroked-button [disabled]="_zoomLevel <= minZoom" (click)="zoomOut()">
        <mat-icon>remove</mat-icon>
      </button>
    </glxy-button-group>
    <glxy-button-group *ngIf="newView" class="zoomButtons">
      <button
        mat-stroked-button
        [glxyTooltip]="'AUTOMATIONS.ZOOM_CONTROL.CENTER' | translate"
        [tooltipPositions]="TOOLTIP_TOP_RIGHT"
        (click)="centerToTrigger.emit()"
        class="locate-trigger-button"
      >
        <mat-icon>zoom_in_map</mat-icon>
      </button>
    </glxy-button-group>
  </div>
</div>
